import { default as _91id_93TnsnusKc0TMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue?macro=true";
import { default as accountsQ5RQpumPGhMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue?macro=true";
import { default as analyticsnu5QCpKHJFMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue?macro=true";
import { default as contactsDA5DE4fVllMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue?macro=true";
import { default as indexybsebWW6OSMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue?macro=true";
import { default as mailboxesPdtyHOs2g4Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue?macro=true";
import { default as newYudWQcW3JIMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue?macro=true";
import { default as schedulehkhYtzlbtvMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue?macro=true";
import { default as _91sequenceId_93qBKiRxhyKEMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue?macro=true";
import { default as indexr8CyWVTGoIMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue?macro=true";
import { default as newprG9MyXOB0Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue?macro=true";
import { default as outreachA1XcHpRQVRMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue?macro=true";
import { default as setupuChreXPLpXMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue?macro=true";
import { default as _91icp_93YD0nCBsWg7Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue?macro=true";
import { default as indexSXWIekjhTZMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue?macro=true";
import { default as campaignsnv9dGjxM6SMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue?macro=true";
import { default as discover0Zi8Vw9rDPMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue?macro=true";
import { default as indexXtgimU7nIxMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue?macro=true";
import { default as opensZMLV2fPltOMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue?macro=true";
import { default as repliesiCsOmJFgJoMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue?macro=true";
import { default as _91listId_93KLseK31Xb0Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue?macro=true";
import { default as all9VMm47Uf6cMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue?macro=true";
import { default as mine6bg0jnUwf8Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue?macro=true";
import { default as sequenceseXn4hQIAOhMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue?macro=true";
import { default as accountbgt3ToufC8Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue?macro=true";
import { default as crmWRDmazQgbNMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue?macro=true";
import { default as engaged_45accountsXnNkTEBgJsMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue?macro=true";
import { default as engaged_45contactspxFbJPHXqXMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue?macro=true";
import { default as exportsKxlOUTB20yMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue?macro=true";
import { default as forbidden_45accountsePSLvYlyW9Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue?macro=true";
import { default as forbidden_45contactsokdZje52koMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue?macro=true";
import { default as imports96ds5hNe1nMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue?macro=true";
import { default as indexxJwjqRvagsMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsKRrmwtaDTaMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue?macro=true";
import { default as mailboxE2mDRBau2gMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue?macro=true";
import { default as notificationsnLMseyuyddMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue?macro=true";
import { default as organizationPCUkBT177FMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue?macro=true";
import { default as replies1dB62EIKWTMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue?macro=true";
import { default as settingszL5OLMKvKdMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue?macro=true";
import { default as advanced_45icpUCEBRzZv4IMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue?macro=true";
import { default as advancedeRbRAO91FSMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue?macro=true";
import { default as employeesN7qZYHUXo0Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue?macro=true";
import { default as job_45openings0vsSRz4o9EMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue?macro=true";
import { default as news2TRDy8JzTFMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue?macro=true";
import { default as websitesyz8FWI01EYMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue?macro=true";
import { default as signinoygnXvzke0Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue?macro=true";
import { default as signupZHgTeWPCz8Meta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue?macro=true";
import { default as testX1QbnsqPWfMeta } from "/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue?macro=true";
export default [
  {
    name: "accounts-id",
    path: "/accounts/:id()",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/accounts/[id].vue")
  },
  {
    name: campaignsnv9dGjxM6SMeta?.name,
    path: "/campaigns",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns.vue"),
    children: [
  {
    name: "campaigns-icp",
    path: ":icp()",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp].vue"),
    children: [
  {
    name: "campaigns-icp-accounts",
    path: "accounts",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/accounts.vue")
  },
  {
    name: "campaigns-icp-analytics",
    path: "analytics",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/analytics.vue")
  },
  {
    name: outreachA1XcHpRQVRMeta?.name,
    path: "outreach",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach.vue"),
    children: [
  {
    name: _91sequenceId_93qBKiRxhyKEMeta?.name,
    path: ":sequenceId()",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId].vue"),
    children: [
  {
    name: "campaigns-icp-outreach-sequenceId-contacts",
    path: "contacts",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/contacts.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId",
    path: "",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/index.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-mailboxes",
    path: "mailboxes",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/mailboxes.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-new",
    path: "new",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/new.vue")
  },
  {
    name: "campaigns-icp-outreach-sequenceId-schedule",
    path: "schedule",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/[sequenceId]/schedule.vue")
  }
]
  },
  {
    name: "campaigns-icp-outreach",
    path: "",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/index.vue")
  },
  {
    name: "campaigns-icp-outreach-new",
    path: "new",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/outreach/new.vue")
  }
]
  },
  {
    name: "campaigns-icp-setup",
    path: "setup",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/[icp]/setup.vue")
  }
]
  },
  {
    name: "campaigns",
    path: "",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/campaigns/index.vue")
  }
]
  },
  {
    name: "discover",
    path: "/discover",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/discover.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/index.vue")
  },
  {
    name: "opens",
    path: "/opens",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/opens.vue")
  },
  {
    name: "replies",
    path: "/replies",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/replies.vue")
  },
  {
    name: "saved-listId",
    path: "/saved/:listId()",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/[listId].vue")
  },
  {
    name: "saved-all",
    path: "/saved/all",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/all.vue")
  },
  {
    name: "saved-mine",
    path: "/saved/mine",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/saved/mine.vue")
  },
  {
    name: "sequences",
    path: "/sequences",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/sequences.vue")
  },
  {
    name: settingszL5OLMKvKdMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-account",
    path: "account",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/account.vue")
  },
  {
    name: "settings-crm",
    path: "crm",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/crm.vue")
  },
  {
    name: "settings-engaged-accounts",
    path: "engaged-accounts",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-accounts.vue")
  },
  {
    name: "settings-engaged-contacts",
    path: "engaged-contacts",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/engaged-contacts.vue")
  },
  {
    name: "settings-exports",
    path: "exports",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/exports.vue")
  },
  {
    name: "settings-forbidden-accounts",
    path: "forbidden-accounts",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-accounts.vue")
  },
  {
    name: "settings-forbidden-contacts",
    path: "forbidden-contacts",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/forbidden-contacts.vue")
  },
  {
    name: "settings-imports",
    path: "imports",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/imports.vue")
  },
  {
    name: "settings",
    path: "",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-mailbox",
    path: "mailbox",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/mailbox.vue")
  },
  {
    name: "settings-notifications",
    path: "notifications",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/notifications.vue")
  },
  {
    name: "settings-organization",
    path: "organization",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/organization.vue")
  },
  {
    name: "settings-replies",
    path: "replies",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/settings/replies.vue")
  }
]
  },
  {
    name: "signals-advanced-icp",
    path: "/signals/advanced-icp",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced-icp.vue")
  },
  {
    name: "signals-advanced",
    path: "/signals/advanced",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/advanced.vue")
  },
  {
    name: "signals-employees",
    path: "/signals/employees",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/employees.vue")
  },
  {
    name: "signals-job-openings",
    path: "/signals/job-openings",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/job-openings.vue")
  },
  {
    name: "signals-news",
    path: "/signals/news",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/news.vue")
  },
  {
    name: "signals-websites",
    path: "/signals/websites",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signals/websites.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/signup.vue")
  },
  {
    name: "test",
    path: "/test",
    component: () => import("/codebuild/output/src326456808/src/actions-runner/_work/mono/mono/out/apps/frontend/pages/test.vue")
  }
]